import * as React from 'react';

export const Footer = () => (
    <div className="bg-footer position-absolute w-100 mr-4 mb-3">
        <div className="footer-logo"/>
        <div className="text-right contact-number">Contact No: 1300 131 194</div>
    </div>
);
